// What a task waits on from its owner (S141, a VPN sign-in since S153): the status pill and the
// pinned cards.
export default {
  answer: (count: number) => (count > 1 ? `Waiting for your answer · ${count}` : "Waiting for your answer"),
  approval: "Waiting for your approval",
  since: (ago: string) => `Asked ${ago}`,
  pinLabel: "Questions waiting for you",
  pinTitle: "The agent is waiting for your answer",
  pinBody: (count: number, ago: string) =>
    count > 1 ? `It asked ${count} questions ${ago}. The step resumes once you answer.` : `It asked a question ${ago}. The step resumes once you answer.`,
  answerBelow: "Answer",
  linkFirst: "The questions are end-to-end encrypted. Link this browser to read and answer them.",
  linkLink: "Devices",
  vpn: "Waiting for VPN sign-in",
  vpnSince: (ago: string) => `Held ${ago}`,
  vpnPinLabel: "VPN sign-in needed",
  vpnPinTitle: "This task is waiting for the VPN",
  vpnPinBody: (ago: string) =>
    `Its environment needs the VPN, which is not connected (held ${ago}). The next step starts once you sign in.`,
  vpnConnect: "Connect VPN",
};
